// /frontend/dashboard/src/main.js
// Application entry for the dashboard frontend.
// English: Switch back to the production shell by mounting App.vue with the production router.
// Thai: สลับกลับไปใช้ production shell โดย mount App.vue กับ production router

import { createApp } from 'vue';
import 'leaflet/dist/leaflet.css';
import App from './App.vue';
import router from './router/index';

const app = createApp(App);
app.use(router);
app.mount('#app');